export function getStyleGroupFilter(tabId) {
  const colorTokens = ['color', 'palette', 'fill', 'stroke']
  const labelTokens = ['label', 'text', 'axis', 'tick']
  const layoutTokens = ['artboard', 'layout', 'legend', 'grid', 'margin', 'sort']

  if (tabId === 'brand') {
    return (groupName) => {
      const normalized = (groupName || '').toLowerCase()
      return colorTokens.some((token) => normalized.includes(token))
    }
  }

  return (groupName) => {
    const normalized = (groupName || '').toLowerCase()

    if (tabId === 'labels') {
      return labelTokens.some((token) => normalized.includes(token))
    }

    if (tabId === 'layout') {
      if (colorTokens.some((token) => normalized.includes(token))) return false
      if (labelTokens.some((token) => normalized.includes(token))) return false
      return (
        layoutTokens.some((token) => normalized.includes(token)) ||
        normalized.length > 0
      )
    }

    return false
  }
}
